import React from 'react';
import styles from './emptyText.scss';

const EmptyText = () => (
  <h2 className={`ads-container ${styles.text}`}>
    {"Vaša spremljena pretraživanja su prazna"}
  </h2>
);

export default EmptyText;



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/EmptyText/index.tsx